export default {"src":"/_next/static/image/public/images/flags/flag_240.1f22305ba851f141d9ee066f4cc7c804.svg","height":16,"width":25};